import React, { Component } from 'react';
import DockPanel from './DockPanel/DockPanel';
import { Row, Form, InputGroup, Button, Modal, Spinner, Table, Tabs, Tab} from "react-bootstrap";
import EnsResolver from "ens-resolver";
import MarkdownPreview from '@uiw/react-markdown-preview';

class AdminModal extends Component {

  constructor(props) {
    super(props);

    this.state ={
      newTeammember: "",
      newArtist: "",
      newCurator: this.props.curator,
      newCuratorPercent: this.props.curatorPercent,
      newBeneficiary: this.props.beneficiary,
      newBeneficiaryPercent: this.props.beneficiaryPercent,
      updateScriptProjectId: "",
      updateScriptTransactionHash: "",
      featuredProjectId: "",

    };

  }

  handleChange = (key) => (e) => this.setState({ [key]: e.target.value });

  clickTeammember = (address) => {
    document.getElementById("removeTeammemberInput").value = address
    this.setState({newTeammember: address})
  }

  clickArtist = (address) => {
    document.getElementById("removeArtistInput").value = address
    this.setState({newArtist: address})
  }

  render() {
    const { platform, contract, isAdminModalOpen, adminLoading, useMetadataServer, userIsContractOwner, userIsPayee, userIsAdmin,
            contractOwnerUpdateWebsiteUrl, contractOwnerUpdateAPIURL, contractOwnerUpdateUseMetadataServer,
            artistScreeningEnabled,
            teamToggleArtistScreeningEnabled, teamAddAuthorizedArtist, teamRemoveAuthorizedArtist,
            contractOwnerUpdateCuratorAddressAndPercent, contractOwnerUpdateBeneficiaryAddressAndPercent,
            adminwithdraw, contractOwnerUpdateArtistPercent, artistTeamUpdateProjectScriptTransactionHash, teamUpdateFeaturedProject,
            artistPercent, curator, curatorPercent, beneficiary, beneficiaryPercent, secondaryRoyaltyPercent, contractOwnerUpdateGlobalSecondaryRoyaltyPercent,
            featuredProjectId,
            contractOwnerAddTeammember, contractOwnerRemoveTeammember, teammembers, getTeammembers, authorizedArtists, getAuthorizedArtists,
            immutablesWEB, immutablesURI, projectFeeInEth, contractBalance,
            contractOwnerUpdateProjectFee,
            closeAdminModal } = this.props;
    const panelFooter = (
      <>
              {(contract && contract.options) ? (
                <>
                <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${contract.options.address}`)}>etherscan</Button>
                </>
              ) : ("")}
                <Button variant="secondary btn-sm" className="font-display" onClick={closeAdminModal}>
                  close
                </Button>
      </>
    );

    return (
      <DockPanel
        show={isAdminModalOpen}
        onClose={closeAdminModal}
        title={<>platform administration</>}
        storageKey="platformAdmin"
        unstyled
        defaultWidth={920}
        defaultHeight={700}
        minWidth={360}
        minHeight={240}
        footer={panelFooter}
      >
        <div className="dock-panel__pad">

              <Tabs defaultActiveKey="admin_force_update_project_script" id="uncontrolled-tab-example">
                { (userIsContractOwner) ? (
                <Tab eventKey="admin_metadata_settings" title="Metadata Settings">
                    <p></p>
                    <MarkdownPreview source={platform.adminServerConfigText} />
                    <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                    <Form.Group as={Row} className="mb-3">
                      <InputGroup className="inputGroup">
                        <InputGroup.Text>Web Server Base URL</InputGroup.Text>
                        <Form.Control required defaultValue={immutablesWEB}
                          onBlur={e => contractOwnerUpdateWebsiteUrl(e.target.value)}/>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                      <InputGroup className="inputGroup">
                        <InputGroup.Text>Metadata Server Base URL</InputGroup.Text>
                        <Form.Control required defaultValue={immutablesURI}
                          onBlur={e => contractOwnerUpdateAPIURL(e.target.value)}/>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                      <InputGroup className="inputGroup">
                        <Form.Check type="checkbox" checked={useMetadataServer} label="Use Metadata Server instead of Smart Contract JSON/SVG" onChange={e => contractOwnerUpdateUseMetadataServer(e.target.checked)}/>
                      </InputGroup>
                    </Form.Group>
                    </>
                      )}
                </Tab>
                ) : ("")}

                { (userIsContractOwner) ? (
                <Tab eventKey="admin_fees_and_payments" title="Fees and Payments">
                <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                      <p></p>
                      <MarkdownPreview source={platform.adminProjectFeeText} />
                      <p></p>
                      <Form.Group as={Row} className="mb-3 align-items-center">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Project Fee (Ξ)</InputGroup.Text>
                          <Form.Control required defaultValue={projectFeeInEth}
                            onBlur={e => contractOwnerUpdateProjectFee(e.target.value)}/>
                        </InputGroup>
                      </Form.Group>

                      <p></p>
                      <MarkdownPreview source={platform.adminArtistPercentageText} />
                      <p></p>

                      <Form.Group as={Row} className="mb-3 align-items-center">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Artist Percent (basis points)</InputGroup.Text>
                          <Form.Control required defaultValue={artistPercent}
                            onBlur={e => contractOwnerUpdateArtistPercent(e.target.value)}/>
                        </InputGroup>
                      </Form.Group>

                    <p></p>
                    <MarkdownPreview source={platform.adminRoyaltyPercentageText} />
                    <p></p>

                    <Form.Group as={Row} className="mb-3 align-items-center">
                      <InputGroup className="inputGroup">
                        <InputGroup.Text>Royalty Percent (basis points)</InputGroup.Text>
                        <Form.Control
                        //required
                        defaultValue={secondaryRoyaltyPercent}
                        onBlur={e => contractOwnerUpdateGlobalSecondaryRoyaltyPercent(e.target.value)}
                        />
                      </InputGroup>
                    </Form.Group>
                    </>
                    )}
                </Tab>
                ) : ("")}

                { (userIsContractOwner) ? (
                <Tab eventKey="admin_curator_settings" title="Curator">
                    <p></p>{platform.adminCuratorText}
                    <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        contractOwnerUpdateCuratorAddressAndPercent(this.state.newCurator, this.state.newCuratorPercent)
                      }}>
                      <Table>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Curator Address</InputGroup.Text>
                          <Form.Control required defaultValue={curator}
                          //onChange={e => this.setState({newBeneficiary: e.target.value })}
                          onChange={this.handleChange('newCurator')}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Curator Percent (basis points)</InputGroup.Text>
                          <Form.Control required defaultValue={curatorPercent}
                           //onChange={e => this.setState({newBeneficiaryPercent: e.target.value })}
                           onChange={this.handleChange('newCuratorPercent')}
                           />
                        </InputGroup>
                      </Form.Group>

                      <div className="text-center mt-3">
                      <input
                        id="submit"
                        type="submit"
                        className="btn btn-success font-display"
                        value="update curator information"
                      />
                      </div>
                      </Table>
                      </Form>
                      </>
                    )}
                </Tab>
                ) : ("")}

                { (userIsContractOwner) ? (
                <Tab eventKey="admin_add_remove_teammember" title="Team Members">
                    <p></p>{platform.adminTeammemberText}
                    <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>

                      <hr/>
                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        contractOwnerAddTeammember(this.state.newTeammember)
                      }}>
                      <Table>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="mb-2">
                          <InputGroup.Text>Add Address</InputGroup.Text>
                          <Form.Control required
                          //onChange={e => this.setState({newBeneficiary: e.target.value })}
                          onChange={this.handleChange('newTeammember')}
                          />
                        </InputGroup>
                      </Form.Group>

                      <div className="text-center mt-3">
                      <input
                        id="submit"
                        type="submit"
                        className="btn btn-success font-display"
                        value="add team member"
                      />
                      </div>
                      </Table>
                      </Form>

                      <hr/>
                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        contractOwnerRemoveTeammember(this.state.newTeammember)
                      }}>
                      <Table>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="mb-2">
                          <InputGroup.Text>Remove Address</InputGroup.Text>
                          <Form.Control required
                          id="removeTeammemberInput"
                          //onChange={e => this.setState({newBeneficiary: e.target.value })}
                          onChange={this.handleChange('newTeammember')}
                          />
                        </InputGroup>
                      </Form.Group>

                      <div className="text-center mt-3">
                      <input
                        id="submit"
                        type="submit"
                        className="btn btn-danger font-display"
                        value="remove team member"
                      />
                      </div>
                      </Table>
                      </Form>

                      <hr/>

                      { (adminLoading) ? (
                        <>
                        <p>Please wait while the team members are loaded ...</p>
                        <div align="center"><Spinner animation="grow" /></div>
                        </>
                        ) : (
                        <>
                          {(teammembers) ? (
                            Object.keys(teammembers).map((address, i) => (
                              (teammembers[address] === true) ? (
                                <Button variant="outline-secondary btn-sm" onClick={() => this.clickTeammember(`${address}`)}>
                                <EnsResolver lookup={address}/> ({address})
                                </Button>
                              ):("")
                            ))
                           ): ("")
                          }

                          <p></p>
                          <div align="center">
                            <Button variant="success btn-sm" className="font-display" onClick={getTeammembers}>Load Team Members</Button>
                          </div>
                        </>
                      )}


                      </>
                    )}
                </Tab>
                ) : ("")}

                { (userIsAdmin) ? (
                <Tab eventKey="admin_add_remove_artist" title="Authorized Artists">
                    <p></p>
                    <MarkdownPreview source={platform.adminApprovedArtistText} />
                    <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                      <hr/>
                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <Form.Check type="checkbox" checked={artistScreeningEnabled} label="Only allow Authorized Artists to create projects."
                          onChange={e => teamToggleArtistScreeningEnabled()}/>
                        </InputGroup>
                      </Form.Group>

                      <hr/>
                      <p></p>
                      <MarkdownPreview source={platform.adminApprovedArtistText2} />
                      <p></p>

                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        teamAddAuthorizedArtist(this.state.newArtist)
                      }}>
                        <Table>

                        <Form.Group as={Row} className="mb-3">
                          <InputGroup className="inputGroup">
                            <InputGroup.Text>Add Address</InputGroup.Text>
                            <Form.Control required
                            //onChange={e => this.setState({newBeneficiary: e.target.value })}
                            onChange={this.handleChange('newArtist')}
                            />
                          </InputGroup>
                        </Form.Group>

                        <div className="text-center mt-3">
                        <input
                          id="submit"
                          type="submit"
                          className="btn btn-success font-display"
                          value="add artist"
                        />
                        </div>
                        </Table>
                      </Form>

                      <hr/>
                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        teamRemoveAuthorizedArtist(this.state.newArtist)
                      }}>
                        <Table>

                        <Form.Group as={Row} className="mb-3">
                          <InputGroup className="inputGroup">
                            <InputGroup.Text>Remove Address</InputGroup.Text>
                            <Form.Control required
                            id="removeArtistInput"
                            //onChange={e => this.setState({newBeneficiary: e.target.value })}
                            onChange={this.handleChange('newArtist')}
                            />
                          </InputGroup>
                        </Form.Group>

                        <div className="text-center mt-3">
                        <input
                          id="submit"
                          type="submit"
                          className="btn btn-danger font-display"
                          value="remove artist"
                        />
                        </div>
                        </Table>
                      </Form>

                      <hr/>
                      { (adminLoading) ? (
                          <>
                            <p>Please wait while the authorized artists are loaded ...</p>
                            <div align="center"><Spinner animation="grow" /></div>
                          </>
                        ) : (
                          <>
                            {(authorizedArtists) ? (
                              Object.keys(authorizedArtists).map((address, i) => (
                                (authorizedArtists[address] === true) ? (
                                  <Button variant="outline-secondary btn-sm" onClick={() => this.clickArtist(`${address}`)}>
                                  <EnsResolver lookup={address}/> ({address})
                                  </Button>
                                ):("")
                              ))
                             ): ("")
                            }
                            <p></p>
                            <div align="center">
                              <Button variant="success btn-sm" className="font-display" onClick={getAuthorizedArtists}>Load Authorized Artists</Button>
                            </div>
                          </>
                      )}
                    </>
                  )}
                </Tab>
                ) : ("")}

                { (userIsAdmin) ? (
                <Tab eventKey="featured_project" title="Featured Project">
                    <p></p>
                    <MarkdownPreview source={platform.adminFeaturedProject} />
                    <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Featured Project ID</InputGroup.Text>
                          <Form.Control
                          required
                          defaultValue={featuredProjectId}
                          //onChange={e => this.setState({newBeneficiary: e.target.value })}
                          onBlur={e => teamUpdateFeaturedProject(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>
                    </>
                    )}
                </Tab>
                ) : ("") }

                <Tab eventKey="admin_force_update_project_script" title="Force Update Project Script">
                    <p></p>
                    <MarkdownPreview source={platform.adminForceUpdateProjectScript} />
                    <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        artistTeamUpdateProjectScriptTransactionHash(this.state.updateScriptProjectId, this.state.updateScriptTransactionHash)
                      }}>
                        <Table>

                        <Form.Group as={Row} className="mb-3">
                          <InputGroup className="inputGroup">
                            <InputGroup.Text>Project ID</InputGroup.Text>
                            <Form.Control required
                            //onChange={e => this.setState({newBeneficiary: e.target.value })}
                            onChange={this.handleChange('updateScriptProjectId')}
                            />
                          </InputGroup>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                          <InputGroup className="inputGroup">
                            <InputGroup.Text>Script Transaction Hash</InputGroup.Text>
                            <Form.Control required
                            //onChange={e => this.setState({newBeneficiary: e.target.value })}
                            onChange={this.handleChange('updateScriptTransactionHash')}
                            />
                          </InputGroup>
                        </Form.Group>

                        <div className="text-center mt-3">
                        <input
                          id="submit"
                          type="submit"
                          className="btn btn-success font-display"
                          value="update project script"
                        />
                        </div>
                        </Table>
                      </Form>
                      </>
                    )}
                </Tab>

                { (userIsContractOwner) ? (
                <Tab eventKey="admin_beneficiary_settings" title="Beneficiary">
                    <p></p>{platform.adminBeneficaryText}
                    <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        contractOwnerUpdateBeneficiaryAddressAndPercent(this.state.newBeneficiary, this.state.newBeneficiaryPercent)
                      }}>
                      <Table>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Beneficiary Address</InputGroup.Text>
                          <Form.Control required defaultValue={beneficiary}
                          //onChange={e => this.setState({newBeneficiary: e.target.value })}
                          onChange={this.handleChange('newBeneficiary')}
                          />
                        </InputGroup>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Beneficiary Percent (basis points)</InputGroup.Text>
                          <Form.Control required defaultValue={beneficiaryPercent}
                           //onChange={e => this.setState({newBeneficiaryPercent: e.target.value })}
                           onChange={this.handleChange('newBeneficiaryPercent')}
                           />
                        </InputGroup>
                      </Form.Group>

                      <div className="text-center mt-3">
                      <input
                        id="submit"
                        type="submit"
                        className="btn btn-success font-display"
                        value="update beneficiary information"
                      />
                      </div>
                      </Table>
                      </Form>
                      </>
                    )}
                </Tab>
                ) : ("")}

                {(userIsPayee) ? (
                <Tab eventKey="admin_withdraw_from_contract" title="Withdraw Funds">
                <p></p>{platform.adminWithdrawText}
                  <p></p>
                  This contract currently has a balance of {contractBalance}Ξ.
                  <p></p>
                    { (adminLoading) ? (
                      <>
                      <p>Please wait while the changes are processed ...</p>
                      <div align="center"><Spinner animation="grow" /></div>
                      </>
                    ) : (
                      <>
                      <Form className="d-flex" onSubmit={(event) => {
                        event.preventDefault()
                        adminwithdraw()
                        // function adminwithdraw() external onlyOwner() {
                      }}>
                      <Table>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Curator Address</InputGroup.Text>
                          <Form.Control readOnly defaultValue={curator}/>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Curator Percent</InputGroup.Text>
                          <Form.Control readOnly defaultValue={curatorPercent}/>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Beneficiary Address</InputGroup.Text>
                          <Form.Control readOnly defaultValue={beneficiary}/>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group as={Row} className="mb-3">
                        <InputGroup className="inputGroup">
                          <InputGroup.Text>Beneficiary Percent</InputGroup.Text>
                          <Form.Control readOnly defaultValue={beneficiaryPercent}/>
                        </InputGroup>
                      </Form.Group>

                      <div className="text-center mt-3">
                      <input
                        id="submit"
                        type="submit"
                        className="btn btn-success font-display"
                        value="withdraw funds"
                      />
                      </div>
                      </Table>
                      </Form>
                      </>
                    )}
                </Tab>
                ):("")}

              </Tabs>

        </div>
      </DockPanel>
    );
  }
}

export default AdminModal;
